"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var fontFamily = _a.fontFamily,
      fontBody = _a.fontBody,
      fontSize2 = _a.fontSize2,
      colorLink = _a.colorLink,
      colorLinkVisited = _a.colorLinkVisited,
      colorTextSecondary = _a.colorTextSecondary;
  return {
    base: __assign(__assign({
      fontFamily: fontFamily
    }, fontBody), {
      display: 'inline',
      color: colorLink.normal,
      cursor: 'pointer',
      textDecoration: 'none',
      '&:hover, &$hover': {
        textDecoration: 'underline',
        color: colorLink.normal
      },
      '&:visited, &$visited': {
        color: colorLinkVisited.normal
      }
    }),
    nested: {
      fontSize: 'inherit',
      lineHeight: 'inherit',
      fontWeight: 'inherit'
    },
    secondary: {
      color: colorTextSecondary.normal,
      textDecoration: 'underline',
      '&:hover, &$hover': {
        textDecoration: 'none',
        color: colorTextSecondary.normal
      },
      '&:visited, &$visited': {
        color: colorTextSecondary.normal
      }
    },
    inherit: {
      color: 'inherit',
      textDecoration: 'underline',
      '&:hover, &$hover': {
        textDecoration: 'none',
        color: 'inherit'
      },
      '&:visited, &$visited': {
        color: 'inherit'
      }
    },
    small: __assign({}, fontSize2),
    hover: {},
    visited: {}
  };
};